import styled from 'styled-components';
import { theme, toRem } from '../../styles';

export const InclusiveMessageWrapper = styled.div`
  border-radius: ${toRem(8)};
  padding: ${toRem(16)};
  background-color: ${theme.colors.white};
  box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
  border: ${toRem(1)} solid var(--horizontal-vertical-rule, ${theme.colors['close-silver']});
  display: flex;
  gap: ${toRem(8)};

  .modify-stay-details {
    height: ${toRem(32)};
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
